
import React, { useState, useEffect } from "react";
import api from "../lib/api.ts";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  sidebarClasses,
} from "react-pro-sidebar";

const SideBar = ({ onCheckBoxChange }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [filters, setFilters] = useState({});
  const [expandedFilters, setExpandedFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});

  const toggleFilter = (filterKey) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [filterKey]: !prev[filterKey],
    }));
  };

  const handleCheckboxChange = (filterKey, id) => {
    setSelectedFilters((prev) => {
      const current = prev[filterKey] || [];
      const updated = {
        ...prev,
        [filterKey]: current.includes(id)
          ? current.filter((item) => item !== id)
          : [...current, id],
      };
      return updated;
    });
  };

  useEffect(() => {
    onCheckBoxChange(selectedFilters);
  }, [selectedFilters, onCheckBoxChange]);

  const handleResetAll = () => {
    setSelectedFilters({});
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const [
          bodyTypeRes,
          driveLineRes,
          transmissionRes,
          fuelTypeRes,
          cylinderRes,
          engineRes,
          highlightRes,
          exteriorColorRes,
          interiorColorRes,
          damageTypeRes,  
        ] = await Promise.all([
          api.get(`/bodytypes`),
          api.get(`/drivelinetypes`),
            api.get(`/transmissiontypes`),
          api.get(`/fueltypes`),
          api.get(`/cylinders`),
          api.get(`/engines`),
          api.get(`/highlights`),
              api.get(`/exteriorcolors`),
          api.get(`/interiorcolors`),
          api.get(`/damagetypes`),
        ]);

        setFilters({
          Featured: [
            { id: "1", name: "Yes" },
            { id: "0", name: "No" },
          ],
          BodyType: bodyTypeRes.data,
          DriveLineType: driveLineRes.data,
          TransmissionType: transmissionRes.data,
          fuelType: fuelTypeRes.data,
          cylinder: cylinderRes.data,
          engine: engineRes.data,
          Highlight: highlightRes.data,
          ExteriorColor: exteriorColorRes.data,
          InteriorColor: interiorColorRes.data,
          primaryDamageType: damageTypeRes.data,
        });
      } catch (err) {
        console.error("Error fetching filters:", err);
      }
    };

    fetchFilters();
  }, []);

  return (
    <div style={{ height: "100vh", position: "relative" }}>
      {/* Toggle Button */}
      <button
        onClick={() => setIsSidebarOpen((prev) => !prev)}
        style={{
          position: "absolute",
          top: 10,
          left: isSidebarOpen ? 260 : 0,
          zIndex: 100,
          // background: "#F15A29",
          color: "#fff",
          borderRadius: "0 8px 8px 0",
          padding: "8px 16px",
          border: "none",
          cursor: "pointer",
          transition: "left 0.3s",
        }}
      >
        {isSidebarOpen ? "Hide Filters" : "Show Filters"}
      </button>

      {/* <Sidebar
        collapsed={!isSidebarOpen}
        // className='bg-darkGraybg'
        width='260px'
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#414042",
            height: "100vh",
          },
        }}
      > */}
      <Sidebar
        collapsed={!isSidebarOpen}
        width='260px'
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#414042",
            // Remove height: "100vh"
          },
        }}
      >
        <Menu
          menuItemStyles={{
            button: {
              "&:hover": {
                backgroundColor: "#414042",
                color: "#fff",
              },
              "&.active": {
                backgroundColor: "#414042",
                color: "#fff",
              },
              color: "#fff",
              backgroundColor: "#414042",
            },
          }}
        >
          {/* Title + Reset */}
          <MenuItem style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
            Filters
            <button
              onClick={handleResetAll}
              style={{
                marginLeft: 10,
                fontSize: 12,
                color: "#fff",
                background: "#414042",
                border: "none",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Reset All
            </button>
          </MenuItem>

          {/* Selected Filters */}
          {Object.entries(selectedFilters).map(([key, ids]) =>
            ids.length > 0 ? (
              <MenuItem key={key} style={{ fontSize: 12 }}>
                <span style={{ fontWeight: "bold" }}>
                  {key.replace(/([A-Z])/g, " $1").trim()}:
                </span>
                <span style={{ marginLeft: 4 }}>
                  {ids
                    .map(
                      (id) =>
                        (filters[key] || []).find((opt) => opt.id === id)?.name
                    )
                    .filter(Boolean)
                    .join(", ")}
                </span>
              </MenuItem>
            ) : null
          )}

          {/* Filters */}
          {/* {Object.entries(filters).map(([key, options]) => (
            <SubMenu
              key={key}
              label={key.replace(/([A-Z])/g, " $1").trim()}
              defaultOpen={!!expandedFilters[key]}
              onClick={() => toggleFilter(key)}
              className='capitalize'
            >
              {options.map((opt) => (
                <MenuItem key={opt.id}>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <input
                      className='capitalize'
                      type='checkbox'
                      value={opt.id}
                      checked={selectedFilters[key]?.includes(opt.id) || false}
                      onChange={() => handleCheckboxChange(key, opt.id)}
                    />
                    <span>{opt.name}</span>
                  </label>
                </MenuItem>
              ))}
            </SubMenu>
          ))} */}
          {Object.entries(filters).map(([key, options]) => (
            <SubMenu
              key={key}
              label={key.replace(/([A-Z])/g, " $1").trim()}
              defaultOpen={!!expandedFilters[key]}
              onClick={() => toggleFilter(key)}
              className='capitalize bg-darkGraybg'
              icon={
                expandedFilters[key] ? (
                  <span style={{ fontSize: 18, color: "#fff" }}>−</span>
                ) : (
                  <span style={{ fontSize: 18, color: "#fff" }}>+</span>
                )
              }
            >
              {options.map((opt) => (
                <MenuItem key={opt.id}>
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <input
                      className='capitalize bg-darkGraybg'
                      type='checkbox'
                      value={opt.id}
                      checked={selectedFilters[key]?.includes(opt.id) || false}
                      onChange={() => handleCheckboxChange(key, opt.id)}
                    />
                    <span>{opt.name}</span>
                  </label>
                </MenuItem>
              ))}
            </SubMenu>
          ))}
        </Menu>
      </Sidebar>
    </div>
  );
};

export default SideBar;
